/**
 * The default sensitivity of a feed.
 */
export const DEFAULT_FEED_SENSITIVITY = 1;
